'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClose", "className", "withPortal", "center"];
import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { addColorSet } from "../../styles/index.mjs";
import { OverlayBackdrop, staticSet } from "./OverlayBackdrop.mjs";
import { isWindowDefined, mergeRefs } from "../../utils.mjs";
/**
 * Backdrop is a tinted overlay on page content, under a popover or model. It disables interactive elements on the page, and uses the "Over media" color set.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-backdrop--docs) |
 * [Encore site](https://encore.spotify.net/patterns/displaying-overlays#blocking-page-interaction) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Backdrop) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?node-id=0-1205)
 */
export var Backdrop = /*#__PURE__*/React.forwardRef(function Backdrop(_ref, ref) {
  var _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    className = _ref.className,
    withPortal = _ref.withPortal,
    center = _ref.center,
    props = _objectWithoutProperties(_ref, _excluded);
  var backdropRef = useRef(null);

  /* if backdrop is clicked, execute onClose */
  var onClick = function onClick(event) {
    if (event.target === backdropRef.current) {
      onClose(event);
    }
  };

  /* if escape key is pressed, execute onClose */
  var onKeydown = function onKeydown(event) {
    if (event.keyCode === 27 || event.code === 'Escape') {
      onClose(event);
    }
  };
  useEffect(function () {
    /* add event listener for escape key press */
    window.addEventListener('keydown', onKeydown, true);

    /* clean up */
    return function () {
      window.removeEventListener('keydown', onKeydown, true);
    };
  });
  var backdrop = /*#__PURE__*/React.createElement(OverlayBackdrop, Object.assign({
    ref: mergeRefs([backdropRef, ref]),
    onClick: onClick,
    className: addColorSet(staticSet, className),
    $center: center
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.Backdrop
  }));

  // document.body does not exist in SSR
  return withPortal && isWindowDefined() ? /*#__PURE__*/ReactDOM.createPortal(backdrop, document.body) : backdrop;
});